import React, { FC } from 'react';
import { Switch, Redirect, RouteComponentProps } from 'react-router-dom';
import ParamsProvider from 'src/app/common/components/ParamsProvider';
import PruRoute from 'src/app/common/components/PruRoute';
import { NOT_FOUND_ERROR_PAGE_PATH } from 'src/app/common/constants';
import { BDM_TEMPLETE_BASE_PATH, BDM_PROMOTION_BASE_PATH, SALESKIT_BASE_PATH } from '../../../constants';
import PromotionImageListingPage, { filterKeys } from './pages/List/PromotionImageListingPage';
import PromotionImageDetailPage from './pages/Create/PromotionImageDetailPage';

const PromotionImageRoutes: FC<RouteComponentProps> = () => {
  return (
    <Switch>
      <Redirect
        exact
        from={`${SALESKIT_BASE_PATH}${BDM_TEMPLETE_BASE_PATH}${BDM_PROMOTION_BASE_PATH}`}
        to={`${SALESKIT_BASE_PATH}${BDM_TEMPLETE_BASE_PATH}${BDM_PROMOTION_BASE_PATH}/list`}
      />
      <PruRoute
        exact
        path={`${SALESKIT_BASE_PATH}${BDM_TEMPLETE_BASE_PATH}${BDM_PROMOTION_BASE_PATH}/list`}
        render={(props) => (
          <ParamsProvider {...props} acceptKeys={filterKeys}>
            <PromotionImageListingPage />
          </ParamsProvider>
        )}
      />
      <PruRoute
        exact
        path={`${SALESKIT_BASE_PATH}${BDM_TEMPLETE_BASE_PATH}${BDM_PROMOTION_BASE_PATH}/view/:id`}
        component={PromotionImageDetailPage}
      />
      <PruRoute
        exact
        path={`${SALESKIT_BASE_PATH}${BDM_TEMPLETE_BASE_PATH}${BDM_PROMOTION_BASE_PATH}/edit/:id`}
        component={PromotionImageDetailPage}
      />
      <PruRoute
        exact
        path={`${SALESKIT_BASE_PATH}${BDM_TEMPLETE_BASE_PATH}${BDM_PROMOTION_BASE_PATH}/create`}
        component={PromotionImageDetailPage}
      />
      <Redirect to={NOT_FOUND_ERROR_PAGE_PATH} />
    </Switch>
  );
};

export default PromotionImageRoutes;
